/**
 * TanStack Query hooks for `spillover-handling`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	spilloverHandlingQueryKeys,
	type CreateSpilloverHandlingBody,
	type ListSpilloverHandlingResponse,
	type SpilloverHandlingRow,
} from "./api";

export function useSpilloverHandlingList(): UseQueryResult<ListSpilloverHandlingResponse, Error> {
	return useQuery({
		queryKey: spilloverHandlingQueryKeys.list(),
		queryFn: list,
	});
}

export function useSpilloverHandlingCreate(): UseMutationResult<SpilloverHandlingRow, Error, CreateSpilloverHandlingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: spilloverHandlingQueryKeys.all });
		},
	});
}

export function useSpilloverHandlingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: spilloverHandlingQueryKeys.all });
		},
	});
}
